import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ContactFilters = ({
  filters,
  onFilterChange,
  activeFiltersCount,
  onClearFilters,
  companies = [],
  roles = [],
  inline = false,
}) => {
  const companyOptions = [
    { value: '', label: 'All Companies' },
    ...companies?.map(c => ({ value: c, label: c }))
  ];

  const roleOptions = [
    { value: '', label: 'All Roles' },
    ...roles?.map(r => ({ value: r, label: r }))
  ];

  const sourceOptions = [
    { value: '', label: 'All Sources' },
    { value: 'Website', label: 'Website' },
    { value: 'Referral', label: 'Referral' },
    { value: 'Google', label: 'Google' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Thumbtack', label: 'Thumbtack' },
    { value: 'Yelp', label: 'Yelp' },
    { value: 'Other', label: 'Other' },
  ];

  if (inline) {
    return (
      <div className="flex flex-wrap gap-2">
        <Select
          placeholder="Company"
          options={companyOptions}
          value={filters?.company}
          onChange={(value) => onFilterChange('company', value)}
          className="w-36"
        />
        <Select
          placeholder="Source"
          options={sourceOptions}
          value={filters?.source}
          onChange={(value) => onFilterChange('source', value)}
          className="w-32"
        />
        {activeFiltersCount > 0 && (
          <Button variant="ghost" size="sm" onClick={onClearFilters} className="text-muted-foreground hover:text-foreground px-2">
            <Icon name="X" size={14} className="mr-1" />
            Clear
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl border border-border p-4 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex flex-wrap gap-2">
          <Select
            placeholder="Company"
            options={companyOptions}
            value={filters?.company}
            onChange={(value) => onFilterChange('company', value)}
            className="w-40"
          />
          <Select
            placeholder="Role / Title"
            options={roleOptions}
            value={filters?.role}
            onChange={(value) => onFilterChange('role', value)}
            className="w-36"
          />
          <Select
            placeholder="Source"
            options={sourceOptions}
            value={filters?.source}
            onChange={(value) => onFilterChange('source', value)}
            className="w-32"
          />
          {activeFiltersCount > 0 && (
            <Button variant="outline" size="sm" onClick={onClearFilters}>
              <Icon name="X" size={14} className="mr-1.5" />
              Clear ({activeFiltersCount})
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactFilters;